// extracted by mini-css-extract-plugin
export var l = "text-module--l--twbPT";
export var text = "text-module--text--vKZVv";
export var text__b = "text-module--text__b--jW0Px";
export var text__cw = "text-module--text__cw--5Kc2y";
export var text__i = "text-module--text__i--IRLkB";
export var text__mb = "text-module--text__mb--ipa31";
export var text__mbLarge = "text-module--text__mbLarge--mQngP";
export var text__s = "text-module--text__s--tzVbO";